export default __webpack_public_path__ + "static/media/Expired.8bb9d007.svg";